import "./App.css";
import "semantic-ui-css/semantic.min.css";
import { ApolloProvider } from "@apollo/client";
import { BrowserRouter, Route } from "react-router-dom";
import { GraphQLClient } from "./GraphQLClient";
import { Routes } from "./Routes";
import { GlobalStyles, ThemeProvider, loadTheme, Notifier } from "grabcad-ui-elements";
import { i18n } from "./i18n";
import { UserProvider } from "./components/User/UserProvider";
import { ErrorBoundary } from "./screens/ErrorBoundary";
import { ApplicationProvider } from "./components/ApplicationProvider";
import isSdkPage from "./utils/isSdkPage";
import { GrabCADApplicationColors } from "grabcad-ui-elements/dist/Theme";
import { useState, useEffect } from "react";
import { extractGenericDomain } from "./utils/genericDomainExtracation";
import { isEmbeddedInGrabCADPrint } from "./utils/isGrabCADPrint";

export const App = () => {
    const [currentTheme, setCurrentTheme] = useState<string>(() => {
        return isEmbeddedInGrabCADPrint
            ? GrabCADApplicationColors.GC_PRINT
            : isSdkPage()
            ? GrabCADApplicationColors.GC_DEVELOP
            : GrabCADApplicationColors.GC_CONTROL;
    });

    const refreshTheme = () => {
        const targetTheme = isEmbeddedInGrabCADPrint
            ? GrabCADApplicationColors.GC_PRINT
            : isSdkPage()
            ? GrabCADApplicationColors.GC_DEVELOP
            : GrabCADApplicationColors.GC_CONTROL;

        if (currentTheme === targetTheme) {
            return;
        }

        setCurrentTheme(targetTheme);
    };

    // This is pure tech debt, this should be gone after infra team will finish their work on GC-101340
    // TODO: GC-102640 Remove this code.
    useEffect(() => {
        function redirectIfHasUrlPrefix() {
            const currentHostname = window.location.hostname;
            const redirectTo = extractGenericDomain(currentHostname);
            // This check will prevent unnecessary redirect if urlPrefix is not present
            if (redirectTo !== currentHostname) {
                window.location.replace(redirectTo);
            }
        }
        redirectIfHasUrlPrefix();
    }, []);

    return i18n(
        <ErrorBoundary>
            <ThemeProvider
                theme={loadTheme({
                    applicationSpecific: currentTheme,
                })}
            >
                <Notifier />
                <GlobalStyles />
                <ApplicationProvider>
                    <BrowserRouter>
                        <Route
                            render={({ location }) => (
                                <ApolloProvider client={GraphQLClient}>
                                    <UserProvider>
                                        <Routes location={location} refreshTheme={refreshTheme} />
                                    </UserProvider>
                                </ApolloProvider>
                            )}
                        />
                    </BrowserRouter>
                </ApplicationProvider>
            </ThemeProvider>
        </ErrorBoundary>
    );
};
